export class UIManager {
    constructor(i18nManager = null) {
        this.i18nManager = i18nManager;
        this.elements = {
            connectSection: document.getElementById('connectSection'),
            activationSection: document.getElementById('activationSection'),
            walletInfo: document.getElementById('walletInfo'),
            walletAddress: document.getElementById('walletAddress'),
            activationFeedback: document.getElementById('activationFeedback'),
            userActivations: document.getElementById('userActivations'),
            userStatus: document.getElementById('userStatus'),
            totalActivations: document.getElementById('totalActivations'),
            totalUsers: document.getElementById('totalUsers'),
            leaderboard: document.getElementById('leaderboard'),
            transactionsList: document.getElementById('transactionsList'),
            errorModal: document.getElementById('errorModal'),
            errorMessage: document.getElementById('errorMessage')
        };
    }

    t(key) {
        return this.i18nManager ? this.i18nManager.t(key) : key;
    }

    showConnectSection() {
        this.elements.connectSection?.classList.remove('hidden');
        this.elements.activationSection?.classList.add('hidden');
    }

    showActivationSection() {
        this.elements.connectSection?.classList.add('hidden');
        this.elements.activationSection?.classList.remove('hidden');
    }

    showWalletInfo(address) {
        if (this.elements.walletInfo && this.elements.walletAddress) {
            this.elements.walletAddress.textContent = this.formatAddress(address);
            this.elements.walletInfo.classList.remove('hidden');
        }
    }

    hideWalletInfo() {
        this.elements.walletInfo?.classList.add('hidden');
    }

    formatAddress(address) {
        if (!address) return '';
        return `${address.substring(0, 8)}...${address.substring(address.length - 6)}`;
    }

    showActivationFeedback(result) {
        if (this.elements.activationFeedback) {
            let message = '🔥 Bitcoin Activated! +1 🔥';
            
            if (result && result.txid) {
                message += `<br><small style="font-size: 0.8em; opacity: 0.8;">✅ ${this.t('transaction_sent')}</small>`;
                message += `<br><small style="font-size: 0.7em; opacity: 0.7;">TXID: ${result.txid.substring(0, 16)}...</small>`;
            } else if (result && result.signature) {
                message += `<br><small style="font-size: 0.8em; opacity: 0.8;">✅ ${this.t('signature_verified')}</small>`;
            }
            
            this.elements.activationFeedback.innerHTML = message;
            this.elements.activationFeedback.classList.remove('hidden');

            setTimeout(() => {
                this.elements.activationFeedback.classList.add('hidden');
            }, 6000);
        }
    }

    updateUserStats(stats) {
        if (this.elements.userActivations) {
            this.elements.userActivations.textContent = stats.activations;
        }
        if (this.elements.userStatus) {
            this.elements.userStatus.textContent = stats.status;
        }
    }

    updateGlobalStats(stats) {
        if (this.elements.totalActivations) {
            this.elements.totalActivations.textContent = stats.totalActivations;
        }
        if (this.elements.totalUsers) {
            this.elements.totalUsers.textContent = stats.totalUsers;
        }
    }

    updateLeaderboard(leaderboard) {
        if (!this.elements.leaderboard) return;

        if (leaderboard.length === 0) {
            this.elements.leaderboard.innerHTML = '<div class="loading">No activations yet. Be the first!</div>';
            return;
        }

        const medals = ['🥇', '🥈', '🥉'];
        
        this.elements.leaderboard.innerHTML = leaderboard.map((item, index) => `
            <div class="leaderboard-item">
                <span class="leaderboard-rank">${medals[index] || `#${index + 1}`}</span>
                <span class="leaderboard-address">${this.formatAddress(item.address)}</span>
                <span class="leaderboard-count">${item.count} 🔥</span>
            </div>
        `).join('');
    }

    showError(message) {
        if (this.elements.errorModal && this.elements.errorMessage) {
            this.elements.errorMessage.textContent = message;
            this.elements.errorModal.classList.remove('hidden');
        }
    }

    hideError() {
        this.elements.errorModal?.classList.add('hidden');
    }

    updateTransactions(transactions) {
        if (!this.elements.transactionsList) return;

        if (transactions.length === 0) {
            this.elements.transactionsList.innerHTML = `<div class="loading">${this.t('no_transactions_prompt')}</div>`;
            return;
        }

        this.elements.transactionsList.innerHTML = transactions
            .sort((a, b) => b.timestamp - a.timestamp)
            .map(tx => {
                const date = new Date(tx.timestamp);
                const timeStr = date.toLocaleString('uk-UA', {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                });
                const txId = tx.txid || '';
                const sig = tx.signature || '';
                const displayId = txId 
                    ? `TX: ${txId.substring(0, 20)}...`
                    : sig 
                    ? `SIG: ${sig.substring(0, 20)}...`
                    : `${this.t('activation')} confirmed`;
                const explorerUrl = txId && !txId.startsWith('ACT_') && !txId.startsWith('DEMO_')
                    ? `https://opscan.org/transactions/${txId}?network=op_testnet`
                    : '';
                const explorerLink = explorerUrl 
                    ? `<a href="${explorerUrl}" target="_blank" style="color: #667eea;">🔍 View on Explorer</a>`
                    : '';
                const txIndex = transactions.length - transactions.indexOf(tx);
                
                return `
                    <div class="transaction-item">
                        <div class="transaction-header">
                            <span class="transaction-number">${this.t('activation')} #${tx.activationNumber || txIndex}</span>
                            <span class="transaction-time">${timeStr}</span>
                        </div>
                        <div class="transaction-verified">✅ ${this.t('signature_verified')}</div>
                        <div class="transaction-signature" title="${txId || sig}">
                            ${displayId}
                        </div>
                        ${explorerLink}
                    </div>
                `;
            })
            .join('');
    }

    formatTime(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleString(this.i18nManager?.getCurrentLang() === 'ua' ? 'uk-UA' : 'en-US', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
}
